import type { CrewMessage } from '@components/InfoChannel/types'
import type { PageType } from '@containers/admin/types'
import type { ICrewMember } from '@shared_types/guest_info_types'
import { asArray } from '@shared_utils/array_utils'
import { callApi } from '@utils/call_api'

export function fetchArrayOfObjects<T, K = unknown> (path: string, errorPrefix?: string, transformResponse?: (res: K) => T[]): Promise<T[]> {
  return new Promise(resolve => {
    callApi(path)
      .then(res => {
        if (transformResponse) {
          res = transformResponse(res)
        }
        resolve(asArray<T>(res))
      })
      .catch(err => {
        const prefix = errorPrefix || `Could not fetch ${path}`
        console.error(`${prefix}: ${err}`)
        resolve([])
      })
  })
}

export function getPagesFromApi () {
  return fetchArrayOfObjects<PageType, { pages: PageType[] }>('api/pages', '', res => {
    return asArray(res?.pages || [])
  })
}

export function getCrewMembers () {
  return fetchArrayOfObjects<ICrewMember>('api/crew-members', 'Could not fetch crew members')
}

export function getCaptainMessages () {
  return fetchArrayOfObjects<CrewMessage>('api/messages/last', 'Could not load captain messages')
}
